import React, { useState } from "react";
import "./App.css";
import Modal from "./components/Modal/Modal";
import Header from "./components/Header/Header";
import Logo from "./assets/logo.png";
import Whatsapp from "./assets/whatsapp.png";
import Mail from "./assets/mail.svg";
import Resume from "./assets/resume.pdf";
import Project from "./components/Projects/Project";
import Javascript from "./assets/Javascript.png";
import Html from "./assets/html.png";
import Css from "./assets/css3.svg";
import Nodejs from "./assets/nodejs.svg";
import React1 from "./assets/react.png";
import Bootstrap from "./assets/bootstrap.png";
import Tailwiind from "./assets/tailwind.png";
import { Fade, Reveal } from "react-awesome-reveal";

function App() {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    modal === true ? setModal(false) : setModal(true);
  };

  const recipientEmail = "lamijibanks@gmail.com";
  function sendMail() {
    window.location.href = `mailto:${recipientEmail}`;
  }

  return (
    <div className="App">
      <nav className={modal === true ? "blur" : ""}>
        <img src={Logo} alt="BM" />

        <div>
          <a href={Resume} download="resume">
            <button className="resume">Download CV</button>
          </a>
          {/** <button className="me" onClick={toggleModal}>
            <img src={Me} alt="My Profile" />
          </button>*/}
        </div>
      </nav>

      <div className="body">
        <Header isBlur={modal === true ? "blur" : ""} onClick={toggleModal} />

        <div className="skills">
          <h2>Skills</h2>
          <div>
            <img src={Html} alt="Html" srcset="" />
            <img src={Css} alt="CSS3" srcset="" />
            <img src={Javascript} alt="Javascript" srcset="" />
            <img src={Bootstrap} alt="Bootstrap" srcset="" />
            <img src={Tailwiind} alt="Tailwind" srcset="" />
            <img src={React1} alt="React" srcset="" />
            <img src={Nodejs} alt="Nodejs" srcset="" />
          </div>
        </div>

        <Fade>
          <Project />
        </Fade>

        <section className="intent">
          <h2>
            I am a freelancer open to collaboration and partnerships. I am
            available for hire and contract jobs. Contact me if you need a
            developer to help you develop your web project and ideas.
            <a href={Resume} download="resume">
              <span className="resume">Download CV</span>
            </a>
          </h2>
          <div className="contacts">
            <h3>Contact Me:</h3>
            <a
              href="https://wa.me/+2349066110020"
              target="_blank"
              rel="noreferrer"
            >
              <button className="whatsapp">
                <img src={Whatsapp} alt="img" srcset="" />
                Whatsapp
              </button>
            </a>

            <button className="mail" onClick={sendMail}>
              <img src={Mail} alt="img" srcset="" />
              Email
            </button>
          </div>
        </section>

        <footer
          style={{
            textAlign: "center",
            padding: ".5rem",
            background: "black",
            color: "white",
          }}
        >
          Banks Mustapha Olamiji &copy;2023
        </footer>
      </div>
      {/* <div className={("overlay", modal === false ? "hidden" : "")}>
        <Modal
          className={modal === false ? "hidden" : ""}
          mail={recipientEmail}
          send={sendMail}
        />
      </div> */}
    </div>
  );
}

export default App;
